/*=========================================================================================
  File Name: betModule.js
  Description: bet Module
==========================================================================================*/


import state from './betState'
import mutations from './betMutations'
import actions from './betActions'
import getters from './betGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}